module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    attrs: {
      "align": "center",
      "id": "chartHeader"
    }
  }, [_vm._v("Waiting for data from server...")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showAsTable),
      expression: "showAsTable"
    }],
    attrs: {
      "type": "checkbox",
      "id": "showAsTableCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showAsTable) ? _vm._i(_vm.showAsTable, null) > -1 : (_vm.showAsTable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showAsTable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showAsTable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showAsTable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showAsTable = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "for": "showAsTableCheckbox"
    }
  }, [_vm._v(" Table View")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chartDiv"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5734b5d8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5734b5d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/convergence-graph/convergence-graph.vue.html
// module id = 1107
// module chunks = 0